// extracted by mini-css-extract-plugin
module.exports = {"body2":"styles_body2__shT7D"};